<template>
  <div v-if="services.length > 0" class="breakdown-item">
    <a v-b-toggle.collapse-services class="cursor-pointer">(<i class="fal fa-plus"></i> Included Services)</a>
    <b-collapse id="collapse-services">
      <div v-for="serviceGroup in services" class="breakdown-services">
        <h6 class="my-2">{{ serviceGroup.name }}</h6>
        <ul class="list-unstyled">
          <li v-for="service in serviceGroup.services" :class="{'green-text': service.standardOnly}"> - {{ service.name }}</li>
        </ul>
      </div>
    </b-collapse>
  </div>
</template>
<script>

export default {
  props: {
    services: {
      type: Array,
      default: []
    }
  }
}
</script>

